<template>
  <el-dialog
    :visible="visible"
    :title="dialogTitle"
    width="800px"
    top="4%"
    class="combo-dialog"
    @opened="afterOpen"
    @close="onClose"
  >
    <div class="scroll-wrap">
      <el-form ref="form" :model="formData" label-width="120px">
        <el-form-item label="品牌" prop="goodsBrand" :rules="rules">
          <el-select
            style="width: 400px"
            v-model="formData.goodsBrand"
            placeholder="请选择"
            size="small"
            clearable
          >
            <el-option
              v-for="item in brandList"
              :key="item.enumCode"
              :label="item.enumText"
              :value="item.enumCode"
            />
          </el-select>
        </el-form-item>
        <el-form-item :label="modelLabel" prop="model" :rules="rules">
          <el-select
            style="width: 400px"
            v-model="formData.model"
            placeholder="请选择"
            size="small"
            clearable
          >
            <el-option
              v-for="item in modelList"
              :key="item.enumCode"
              :label="item.enumText"
              :value="item.enumCode"
            />
          </el-select>
        </el-form-item>
        <el-form-item v-if="goodsType === 1" label="内存" prop="memory" :rules="rules">
          <el-select
            style="width: 400px"
            v-model="formData.memory"
            placeholder="请选择"
            size="small"
            clearable
          >
            <el-option
              v-for="item in memoryList"
              :key="item.enumCode"
              :label="item.enumText"
              :value="item.enumCode"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="颜色" prop="colorList" :rules="rules">
          <el-select
            style="width: 400px"
            v-model="formData.colorList"
            placeholder="请选择"
            size="small"
            multiple
            clearable
          >
            <el-option
              v-for="item in colorList"
              :key="item.enumText"
              :label="item.enumText"
              :value="item.enumCode"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="封面图" prop="coverImage" :rules="rules">
          <FileUpload
            :name.sync="formData.coverImage"
            :url="formData.coverImageUrl"
          ></FileUpload>
        </el-form-item>
        <el-form-item v-if="goodsType === 1 && (mode === 'create' || showAllFields)" label="原始官网价" prop="originOfficialPrice" :rules="(mode === 'create' || showAllFields) ? rules : []">
          <el-input-number
            style="width: 400px"
            size="small"
            v-model="formData.originOfficialPrice"
            :precision="2"
            :step="0.01"
            :min="0"
          ></el-input-number>
        </el-form-item>
        <el-form-item v-if="mode === 'create' || showAllFields" label="官网价" prop="officialPrice" :rules="(mode === 'create' || showAllFields) ? rules : []">
          <el-input-number
            style="width: 400px"
            size="small"
            v-model="formData.officialPrice"
            :precision="2"
            :step="0.01"
            :min="0"
          ></el-input-number>
        </el-form-item>
        <!-- 买断金已去掉 -->
        <el-form-item v-if="mode === 'create' || showAllFields" label="全新售价" prop="minPrice" :rules="(mode === 'create' || showAllFields) ? freshPriceRules : []">
          <div>
            <el-input-number
              style="width: 190px"
              size="small"
              v-model="formData.minPrice"
              :precision="2"
              :step="0.01"
              :min="0"
            ></el-input-number>
            ~
            <el-input-number
              style="width: 190px"
              size="small"
              v-model="formData.maxPrice"
              :precision="2"
              :step="0.01"
              :min="0"
            ></el-input-number>
          </div>
        </el-form-item>
        <el-form-item v-if="goodsType === 1 && (mode === 'create' || showAllFields)" label="二手售价" prop="oldMinPrice" :rules="(mode === 'create' || showAllFields) ? oldPriceRules : []">
          <div>
            <el-input-number
              style="width: 190px"
              size="small"
              v-model="formData.oldMinPrice"
              :precision="2"
              :step="0.01"
              :min="0"
            ></el-input-number>
            ~
            <el-input-number
              style="width: 190px"
              size="small"
              v-model="formData.oldMaxPrice"
              :precision="2"
              :step="0.01"
              :min="0"
            ></el-input-number>
          </div>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="onClose">取消</el-button>
      <el-button type="primary" @click="save" :loading="saving">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { getBrandListAPI, getAttrListAPI, getDetailAPI, addAPI, editAPI } from "../api";
import { EnumGoodsGroupCode } from "@/enum/dict/index.js";
import FileUpload from "@/components/file-upload/index.vue";

export default {
  name: "StoreGoodsAddDialog",
  components: { FileUpload },
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
    goodsType: {
      type: Number,
      default: 1,
    },
    mode: {
      type: String,
      default: "create",
      validator: (value) => ["create", "edit"].includes(value),
    },
    showAllFields: {
      type: Boolean,
      default: false,
    },
    id: {
      type: [Number, String],
      default: null,
    },
  },
  data() {
    return {
      saving: false,
      rules: [{ required: true, message: "该项不能为空", trigger: "blur" }],
      freshPriceRules: [
        { required: true, message: "该项不能为空", trigger: "blur" },
        { validator: this.validateFreshPrice, trigger: "change" },
      ],
      oldPriceRules: [
        { required: true, message: "该项不能为空", trigger: "blur" },
        { validator: this.validateOldPrice, trigger: "change" },
      ],
      brandList: [],
      modelList: [],
      memoryList: [],
      colorList: [],
      formData: {
        goodsType: 1,
        goodsBrand: "",
        model: "",
        memory: "",
        colorList: [],
        coverImage: "",
        originOfficialPrice: "",
        officialPrice: "",
        minPrice: "",
        maxPrice: "",
        oldMinPrice: "",
        oldMaxPrice: "",
      },
    };
  },
  computed: {
    dialogTitle() {
      const prefix = this.mode === "edit" ? "编辑" : "新增";
      return this.goodsType === 1 ? `${prefix}3C商品` : `${prefix}电车商品`;
    },
    modelLabel() {
      return this.goodsType === 1 ? "机型" : "车型";
    },
  },
  methods: {
    async afterOpen() {
      this.$refs.form.resetFields();
      this.getBrandList();
      this.getModelList();
      if (this.goodsType === 1) {
        this.getMemoryList();
      }
      this.getColorList();

      if (this.mode === "edit" && this.id) {
        const detail = await getDetailAPI(this.id);
        this.formData = detail;
      } else {
        this.formData = this.$options.data().formData;
        this.formData.goodsType = this.goodsType;
      }
    },
    onClose() {
      this.$emit("update:visible", false);
    },
    async getBrandList() {
      this.brandList = await getBrandListAPI({
        goodsType: this.goodsType,
      });
    },
    async getModelList() {
      let params = {
        goodsType: this.goodsType,
        groupCode: EnumGoodsGroupCode.MODEL,
      };
      const res = await getAttrListAPI(params);
      this.modelList = res || [];
    },
    async getMemoryList() {
      let params = {
        goodsType: this.goodsType,
        groupCode: EnumGoodsGroupCode.MEMORY,
      };
      const res = await getAttrListAPI(params);
      this.memoryList = res || [];
    },
    async getColorList() {
      let params = {
        goodsType: this.goodsType,
        groupCode: EnumGoodsGroupCode.COLOR,
      };
      const res = await getAttrListAPI(params);
      this.colorList = res || [];
    },
    validateFreshPrice(rule, value, callback) {
      const { minPrice, maxPrice } = this.formData;
      if (minPrice !== "" && maxPrice !== "" && Number(minPrice) > Number(maxPrice)) {
        callback(new Error("最高价不能低于最低价"));
      } else {
        callback();[]
      }
    },
    validateOldPrice(rule, value, callback) {
      const { oldMinPrice, oldMaxPrice } = this.formData;
      if (oldMinPrice !== "" && oldMaxPrice !== "" && Number(oldMinPrice) > Number(oldMaxPrice)) {
        callback(new Error("最高价不能低于最低价"));
      } else {
        callback();
      }
    },
    save() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          this.saving = true;
          try {
            if (this.mode === "edit") {
              const { originOfficialPrice, officialPrice, minPrice, maxPrice, oldMinPrice, oldMaxPrice, ...editData } = this.formData;
              await editAPI(editData);
              this.$message.success("编辑成功");
            } else {
              await addAPI(this.formData);
              this.$message.success("新增成功");
            }
            this.onClose();
            this.$emit("refreshList");
          } catch (error) {
            this.$message.error(this.mode === "edit" ? "编辑失败" : "新增失败");
          } finally {
            this.saving = false;
          }
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
.combo-dialog {
  /deep/ .el-form-item__label {
    font-weight: bold;
  }
}

.scroll-wrap {
  max-height: 82vh;
  overflow-y: auto;
}
</style>
